import { AdminRestClient } from "@roberty/rest"

const RestClient = new AdminRestClient()

export default RestClient